import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/data/content";
import { TEST_IDS } from "@/constants/testIds";

export default function Testimonials() {
  return (
    <section
      data-testid={TEST_IDS.testimonials.root}
      className="py-24 md:py-40 border-t border-[#E5E1DA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 grid md:grid-cols-12 gap-6 items-end">
          <div className="md:col-span-2 eyebrow">Kind words</div>
          <h2 className="md:col-span-8 font-serif-display font-black tracking-tight text-[clamp(38px,6vw,84px)] leading-[0.95]">
            From the pastors
            <br />
            <span className="italic text-[#E07A5F]">who trust us on Mondays.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={TEST_IDS.testimonials.item(i + 1)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
              className={`relative rounded-3xl p-8 md:p-10 flex flex-col justify-between ${
                i === 1 ? "bg-[#264653] text-[#FDFCFB]" : "bg-[#FDFCFB] border border-[#E5E1DA]"
              }`}
            >
              <span
                aria-hidden="true"
                className={`font-serif-display leading-none select-none ${
                  i === 1 ? "text-white/15" : "text-[#E07A5F]/30"
                }`}
                style={{ fontSize: "120px", marginBottom: "-32px" }}
              >
                “
              </span>
              <blockquote className="font-serif-display text-[22px] md:text-[26px] leading-[1.25] tracking-tight">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <img
                  src={t.photo}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border border-black/5"
                />
                <div>
                  <div className={`text-sm font-medium ${i === 1 ? "" : "text-[#1C1C1A]"}`}>{t.name}</div>
                  <div className={`text-[12px] tracking-widest uppercase ${i === 1 ? "text-white/60" : "text-[#787672]"}`}>
                    {t.role} · {t.church}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
